/**
 * Smooth accordion animation for <details> elements inside <custom-accordion>.
 * Uses explicit height transitions for reliable open/close animation.
 */
(function () {
  'use strict';

  var DURATION = 300;
  var EASING = 'ease';

  class CustomAccordion extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('details.product-accordion').forEach(function (details) {
        var summary = details.querySelector('summary');
        if (!summary) return;
        var animation = null;

        summary.addEventListener('click', function (e) {
          e.preventDefault();

          var body = details.querySelector('.accordion-body');
          if (!body) return;

          // Cancel any running animation
          if (animation) {
            animation.cancel();
          }

          if (details.open) {
            // Closing
            var startHeight = body.offsetHeight + 'px';
            animation = body.animate(
              { height: [startHeight, '0px'] },
              { duration: DURATION, easing: EASING }
            );
            body.style.overflow = 'hidden';
            animation.onfinish = function () {
              details.open = false;
              body.style.height = '';
              body.style.overflow = '';
              animation = null;
            };
          } else {
            // Opening
            details.open = true;
            var endHeight = body.offsetHeight + 'px';
            animation = body.animate(
              { height: ['0px', endHeight] },
              { duration: DURATION, easing: EASING }
            );
            body.style.overflow = 'hidden';
            animation.onfinish = function () {
              body.style.height = '';
              body.style.overflow = '';
              animation = null;
            };
          }
        });
      });
    }
  }

  customElements.define('custom-accordion', CustomAccordion);
})();
